/*
  Define display configuration options at region, brand, or both.
  
  Use this as an alternative to the BE data-configuration json, for small/visual brand requests.
  We don't want to overload the BE provided config with 'non-essential' display configs.

  While it might not be considered a best practice, this solution will speed up delivery efforts for some of these display discrepancy requests.
  Always decided with the team, if a new feature flag is more suitable to be added here.
*/

export type DisplayConfig = {
  showUPSPriceAsFreeIfZero?: boolean,
};

export const defaultDisplayConfig: DisplayConfig = {
  showUPSPriceAsFreeIfZero: true,
};

const RegionConfig = new Map<string, DisplayConfig>();
const BrandConfig = new Map<string, DisplayConfig>();
const BrandLocaleConfig = new Map<string, DisplayConfig>();

export const getDisplayConfig = (brandName: string, region: string): DisplayConfig => {
  const regionConfig = RegionConfig.get(region?.toLowerCase());
  const brandConfig = BrandConfig.get(brandName?.toLowerCase());
  const brandLocaleConfig = BrandLocaleConfig.get(`${brandName}-${region}`.toLowerCase());

  const displayConfig = {
    ...defaultDisplayConfig,
    ...regionConfig,
    ...brandConfig,
    ...brandLocaleConfig,
  };

  return displayConfig;
};

BrandLocaleConfig.set('esteelauder-us', {
  showUPSPriceAsFreeIfZero: false,
});
